import index from './index.vue';
import { BillingForm } from './all.type';

export default index;
export {
    BillingForm
};